import { GET_OWNED_SHARED_MESSAGES, GET_MESSAGE_SHARING_STATUS, GET_SHARED_MESSAGE, GET_SHARED_MESSAGES, GET_MESSAGE_SHARES, GET_MESSAGE_PUBLISH_STATUS } from './sharing/message-sharing';
import { GET_FOLDER_REFERENCES } from './sharing/get-folder-references';
import { FIND_FOLDERS } from './folder/find-folders';
import { GET_FOLDER_CONTENT } from './folder/get-folder-content';
import { GET_HOME_FOLDERS } from './folder/get-home-folders';
import { GET_PINNED_FOLDERS } from './folder/get-pinned-folders';
import { GET_TRASH_FOLDERS_GLOBAL } from './folder/get-trash-folders-global';

import { FILTER_MESSAGES } from './message/filter-messages';
import { FIND_MESSAGES } from './message/find-messages';
import { SEARCH_MESSAGES } from './message/search-messages';
import { GET_TASK_FOLDERS } from './message/get-checkbox-messages-global';
import { GET_MESSAGE } from './message/get-message';
import { GET_ARTIFACTS } from './message/get-artifacts';
import { GET_MESSAGE_REPLY_PREVIEW } from './message/get-message-reply-preview';
import { GET_MESSAGE_REVISIONS } from './message/get-message-revisions';
import { GET_MESSAGE_THREAD } from './message/get-message-thread';
import { GET_REMINDER_MESSAGES_GLOBAL } from './message/get-reminder-messages-global';
import { GET_STARRED_FOLDERS } from './message/get-starred-messages-global';
import { GET_TRASH_MESSAGES_GLOBAL } from './message/get-trash-messages-global';
import { GET_TRASH_MESSAGES_IN_FOLDER } from './message/get-trash-messages-in-folder';
import { DOWNLOAD_FILE } from './message/download-file';
import { GET_MESSAGES_AROUND } from './message/get-messages-around-message';

import { GET_ALL_USERS } from './user/get-all-users';
import { GET_ALL_ANALYTICS } from './user/get-all-analytics';
import { ME } from './user/me';
import { MY_EXPORT_STATUS } from './user/my-export-status';
import { GET_ADMIN_DATA_EXPORTS } from './user/get-admin-data-exports';
import { FIND_USERS } from './user/find-users';
import { GET_EMAIL_CAMPAIGN_RECIPIENT_COUNT } from './user/get-email-campaign-recipient-count';
import { GET_EMAIL_CAMPAIGN_ELIGIBLE_USERS } from './user/get-email-campaign-eligible-users';
import { GET_EMAIL_CAMPAIGN_RESULT } from './user/get-email-campaign-result';
import { GET_PUSH_CAMPAIGN_RECIPIENT_COUNT } from './user/get-push-campaign-recipient-count';
import { GET_PUSH_CAMPAIGN_ELIGIBLE_USERS } from './user/get-push-campaign-eligible-users';
import { GET_PUSH_CAMPAIGN_RESULT } from './user/get-push-campaign-result';
import { GET_CREDITS } from './user/get-credits';
import { GET_CREDITS_USAGE_PERCENT } from './user/get-credits-usage-percent';
import { PREVIEW_EMAIL } from './user/preview-email';
import { GET_AVAILABLE_CAMPAIGN_TEMPLATES } from './user/get-available-campaign-templates';
import { GET_AI_ORGANIZATION_BACKFILL_JOBS } from './user/get-ai-organization-backfill-jobs';
import { GET_ADMIN_REMINDER_DEBUG } from './user/get-admin-reminder-debug';
import { GET_ADMIN_AUDIO_TRANSCRIPTION_DEBUG } from './user/get-admin-audio-transcription-debug';
import { GET_ADMIN_VIDEO_FRAME_ANALYSIS_DEBUG } from './user/get-admin-video-frame-analysis-debug';
import { GET_ADMIN_ARTIFACT_DIAGNOSTIC } from './user/get-admin-artifact-diagnostic';
import { GET_ADMIN_MCP_USAGE_STATS } from './user/get-admin-mcp-usage-stats';
import { LIST_API_TOKENS } from './user/list-api-tokens';
import { GET_WRAPPED_STATS } from './user/get-wrapped-stats';

import { GET_SHARED_FOLDERS } from './sharing/get-shared-folders';
import { GET_OWNED_SHARED_FOLDERS } from './sharing/get-owned-shared-folders';
import { GET_SHARED_FOLDER_CONTENT } from './sharing/get-shared-folder-content';
import { GET_FOLDER_SHARES } from './sharing/get-folder-shares';
import { GET_FOLDER_PUBLISH_STATUS } from './sharing/get-folder-publish-status';
import { GET_PUBLISHED_FOLDER } from './sharing/get-published-folder';
import { GET_PUBLISHED_MESSAGE } from './sharing/get-published-message';
import { FOLDER_CHANGED_SINCE } from './sharing/folder-changed-since';

import { GET_REVIEWS } from './review/get-reviews';
import { GET_REVIEW, GET_REVIEW_BY_PERIOD } from './review/get-review';

import { GET_ACTIVE_PLANS } from './purchase/get-active-plans';
import { GET_USER_PURCHASES } from './purchase/get-user-purchases';
import { GET_ALL_PLANS } from './plan/get-all-plans';
import { GET_AVAILABLE_CHAT_MODELS } from './ai/get-available-chat-models';
import { GET_AVAILABLE_CHAT_ACTIONS } from './ai/get-available-chat-actions';
import { GET_SYSTEM_CHAT_ACTIONS } from './ai/get-system-chat-actions';
import { GET_MY_CHAT_ACTIONS } from './ai/get-my-chat-actions';
import { GET_PUBLIC_CHAT_ACTIONS } from './ai/get-public-chat-actions';
import { ACTIVE_ANNOUNCEMENT_BANNER, ANNOUNCEMENT_BANNERS } from '../announcementBanners';

const QUERY = {
    GET_OWNED_SHARED_MESSAGES, GET_MESSAGE_SHARING_STATUS, GET_SHARED_MESSAGE, GET_SHARED_MESSAGES, GET_MESSAGE_SHARES, GET_MESSAGE_PUBLISH_STATUS,
    GET_HOME_FOLDERS,
    GET_PINNED_FOLDERS,
    GET_FOLDER_CONTENT,
    FIND_FOLDERS,
    GET_TASK_FOLDERS,
    // Legacy cache helpers still resolve this key while their paginated-cache
    // migration is in progress. The grouped Tasks screen uses GET_TASK_FOLDERS.
    GET_CHECKBOX_MESSAGES_GLOBAL: GET_TASK_FOLDERS,
    FIND_MESSAGES,
    GET_MESSAGE,
    GET_ARTIFACTS,
    GET_MESSAGE_REPLY_PREVIEW,
    GET_MESSAGE_REVISIONS,
    GET_MESSAGE_THREAD,
    GET_REMINDER_MESSAGES_GLOBAL,
    FILTER_MESSAGES,
    SEARCH_MESSAGES,
    GET_STARRED_FOLDERS,
    // Legacy cache helpers still resolve this key while their paginated-cache
    // migration is in progress. The grouped Stars screen uses GET_STARRED_FOLDERS.
    GET_STARRED_MESSAGES_GLOBAL: GET_STARRED_FOLDERS,
    GET_TRASH_FOLDERS_GLOBAL,
    GET_TRASH_MESSAGES_GLOBAL,
    GET_TRASH_MESSAGES_IN_FOLDER,
    DOWNLOAD_FILE,
    GET_ALL_USERS,
    GET_ALL_ANALYTICS,
    ME,
    FIND_USERS,
    GET_ACTIVE_PLANS,
    GET_ALL_PLANS,
    GET_USER_PURCHASES,
    GET_AVAILABLE_CHAT_MODELS,
    GET_AVAILABLE_CHAT_ACTIONS,
    GET_SYSTEM_CHAT_ACTIONS,
    GET_MY_CHAT_ACTIONS,
    GET_PUBLIC_CHAT_ACTIONS,
    GET_MESSAGES_AROUND,
    GET_EMAIL_CAMPAIGN_RECIPIENT_COUNT,
    GET_EMAIL_CAMPAIGN_ELIGIBLE_USERS,
    GET_EMAIL_CAMPAIGN_RESULT,
    GET_PUSH_CAMPAIGN_RECIPIENT_COUNT,
    GET_PUSH_CAMPAIGN_ELIGIBLE_USERS,
    GET_PUSH_CAMPAIGN_RESULT,
    GET_CREDITS,
    GET_CREDITS_USAGE_PERCENT,
    PREVIEW_EMAIL,
    GET_AVAILABLE_CAMPAIGN_TEMPLATES,
    GET_AI_ORGANIZATION_BACKFILL_JOBS,
    GET_ADMIN_REMINDER_DEBUG,
    GET_ADMIN_AUDIO_TRANSCRIPTION_DEBUG,
    GET_ADMIN_VIDEO_FRAME_ANALYSIS_DEBUG,
    GET_ADMIN_ARTIFACT_DIAGNOSTIC,
    GET_ADMIN_MCP_USAGE_STATS,
    GET_REVIEWS,
    GET_REVIEW,
    GET_REVIEW_BY_PERIOD,
    MY_EXPORT_STATUS,
    GET_ADMIN_DATA_EXPORTS,
    LIST_API_TOKENS,
    GET_WRAPPED_STATS,
    GET_FOLDER_REFERENCES,
    GET_SHARED_FOLDERS,
    GET_OWNED_SHARED_FOLDERS,
    GET_SHARED_FOLDER_CONTENT,
    GET_FOLDER_SHARES,
    GET_FOLDER_PUBLISH_STATUS,
    GET_PUBLISHED_FOLDER,
    GET_PUBLISHED_MESSAGE,
    ACTIVE_ANNOUNCEMENT_BANNER,
    ANNOUNCEMENT_BANNERS,
    FOLDER_CHANGED_SINCE
};

export default QUERY;
